export default "__VITE_ASSET__I2Zmc92B__"